module.exports = __webpack_public_path__ + "media/libro_animation.13283f6e.mp4";